export default __webpack_public_path__ + "61ac1af8b3a47c94f7bab4ee94a9c6b8.png";